import { accountKeys } from "@apis/accounts/queryKeys"
import { useUpdateAccountNumberHistoryMutation } from "@apis/accounts/useAccounts"
import type { IAccountNumberHistory } from "@apis/accounts/types"
import { useAuthUserDetails } from "@apis/users/useUsers"
import { Button } from "@components/ui/button"
import { useHasPermissions } from "@hooks/useHasPermissions"
import { useQueryClient } from "@tanstack/react-query"
import { Loader2 } from "lucide-react"
import { toast } from "sonner"

type TUpdateAccountNumberHistoryButtonProps = {
  accountNumberHistory: IAccountNumberHistory
}
export const UpdateAccountNumberHistoryButton = ({
  accountNumberHistory,
}: TUpdateAccountNumberHistoryButtonProps) => {
  const queryClient = useQueryClient()
  const updateAccountNumberHistory = useUpdateAccountNumberHistoryMutation()
  const getAuthUserDetailsQuery = useAuthUserDetails()
  const accountId = String(accountNumberHistory.account_id)
  const { canUpdateAccountNumber } = useHasPermissions()

  const handleClick = () => {
    updateAccountNumberHistory.mutate(
      {
        account_id: accountId,
        request: {
          selected_history: accountNumberHistory,
          agent_id: getAuthUserDetailsQuery.data?.email || "",
        },
      },
      {
        onSuccess: () => {
          toast.success("Successfully updated account number history!")
          queryClient.invalidateQueries({
            queryKey: accountKeys.detail(accountId),
          })
        },
        onError: (error) =>
          toast.error(`Error updating account number history! ${error}`),
      },
    )
  }

  return (
    <Button
      onClick={handleClick}
      size={"sm"}
      disabled={updateAccountNumberHistory.isPending || !canUpdateAccountNumber}
    >
      {updateAccountNumberHistory.isPending ? (
        <Loader2 className="tw:animate-spin" />
      ) : canUpdateAccountNumber ? (
        <span>Set as current</span>
      ) : (
        <span>Requires Ops Permissions</span>
      )}
    </Button>
  )
}
